module.exports = function () {
    // Select all links with hashes
    jQuery('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .on('click', function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = jQuery(this.hash),
                    currentPosition = jQuery(window).scrollTop();

                target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();

                    if (currentPosition < target.offset().top) {
                        jQuery('html, body').animate({
                            scrollTop: target.offset().top
                        });
                    } else {
                        jQuery('html, body').animate({
                            scrollTop: target.offset().top - jQuery('#site-header').outerHeight()
                        });
                    }
                }
            }
        });
    if (window.location.hash) {
        var hash = window.location.hash;

        setTimeout(() => {
            if (jQuery(hash).length) {

                jQuery('html, body').animate({
                    scrollTop: 0
                }, 0, 0);

                setTimeout(() => {
                    jQuery('html, body').animate({
                        scrollTop: jQuery(hash).offset().top
                    });
                }, 200);

            }
        }, 200)
    }
};